import Dependencies from '../utilities/dependencies';
import DependencyManager from '../utilities/dependency-manager';

export default class Gallery {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getHolderSelectors = () => ['.gallery-wrapper'];

	/**
	 * Dependencies that this module requires
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getDependencies = () => [];

	/**
	 * Runtime injected CSS classes
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getClassList = () => Object.create({});
	/** @type {HTMLElement} */
	#holderElement;

	static alpineData;

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		this.#holderElement = holderElement;

		document.addEventListener('alpine:init', () => {
			Gallery.alpineData = Alpine.reactive({
				slides: [],
			});
			Alpine.data('gallery', () => (Gallery.alpineData));
			this.#holderElement.style.height = '0';
			this.#holderElement.querySelector('button').style.position = 'absolute';
		});
		DependencyManager.loadDependencies([Dependencies.libraries.alpine]);

		this.#holderElement.querySelector('.btn-close').addEventListener('click', (event) => {
			event.preventDefault();
			document.querySelector('html').style.overflow = 'unset';
			this.#holderElement.style.height = '0';
			this.#holderElement.querySelector('button').style.position = 'absolute';
		});
	}
}
